import { useEffect, useState } from 'react';

export function useMediaQuery(query: string, padrao = false): boolean {
  const [casa, setCasa] = useState(padrao);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const atualizar = () => setCasa(mql.matches);
    atualizar();
    if (mql.addEventListener) {
      mql.addEventListener('change', atualizar);
      return () => mql.removeEventListener('change', atualizar);
    }
    mql.addListener?.(atualizar);
    return () => mql.removeListener?.(atualizar);
  }, [query]);

  return casa;
}

export default useMediaQuery;
